export default {
  '/busca-parceiro': {
    hideHeader: true
  }
}
